import React from "react"
import { ShelfItemBookEntity } from "@/app/entities/ShelfEntity"
import BookList from "./BookList"
import AddToLibraryButton from "./AddToLibraryButton"
import utcToKoreanDateTime from "@/utils/utcToKoreanDateTime"

interface BookListContentProps {
  books: ShelfItemBookEntity[]
  selectedCount: number
  onAddToLibrary: () => void
  captureDate?: string
}

/**
 * 도서 목록 성공 상태의 전체 콘텐츠 컴포넌트
 * 헤더, 도서 목록, 하단 안내, 등록 버튼을 포함
 */
const BookListContent = React.memo<BookListContentProps>(
  ({ books, selectedCount, onAddToLibrary, captureDate }) => {
    return (
      <>
        {/* Header Section - 정적 JSX 인라인화 */}
        <div className="mb-6 px-5 pt-8 sm:px-8">
          <p className="typo-rl-body2 mb-3 w-full max-w-sm text-left font-normal text-rl-gray-font-normal sm:max-w-none">
            촬영한 책 목록을 확인해 주세요.
            <br />
            선택한 도서는 내 서재에 등록됩니다.
          </p>
          <p className="typo-rl-caption font-normal text-rl-gray-font-caption">
            책장 촬영 일시 :{" "}
            {captureDate
              ? utcToKoreanDateTime(captureDate, "YYYY.MM.DD HH:mm")
              : "--"}
          </p>
        </div>

        {/* Book List */}
        <BookList books={books} />

        {/* Footer Notice - 정적 JSX 인라인화 */}
        <div className="relative pb-[130px] pl-5 sm:pl-8">
          <div className="flex items-center">
            <div className="h-1 w-1 flex-shrink-0 rounded-full bg-rl-border_line-light-01"></div>
            <p className="typo-rl-caption ml-3 font-normal text-rl-gray-font-press">
              ISBN이 등록되지 않은 도서는 반영되지 않습니다.
            </p>
          </div>
          <div className="mt-1 flex items-center">
            <div className="h-1 w-1 flex-shrink-0 rounded-full bg-rl-border_line-light-01"></div>
            <p className="typo-rl-caption ml-3 font-normal text-rl-gray-font-press">
              실제 도서와 다른 도서로 확인되면 목록에서 제외해주세요.
            </p>
          </div>
        </div>

        {/* Bottom Button */}
        <AddToLibraryButton
          selectedCount={selectedCount}
          onAddToLibrary={onAddToLibrary}
        />
      </>
    )
  },
)

BookListContent.displayName = "BookListContent"

export default BookListContent
